import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export class UserGroupRepository extends EntityRepository<
  AppSynchronizationEnvironmentTypes,
  EntityName.UserGroup,
  AppEntityManagerEntityTypesByEntityName
> {}
